import { render, staticRenderFns } from "./fexam.vue?vue&type=template&id=2cf22976&scoped=true&"
import script from "./fexam.vue?vue&type=script&lang=js&"
export * from "./fexam.vue?vue&type=script&lang=js&"
import style0 from "./fexam.vue?vue&type=style&index=0&id=2cf22976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf22976",
  null
  
)

export default component.exports